import { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { getEmbedUrl } from "@/lib/video";

const ImageUpload = ({ label, value, onChange, testId }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const isVideo = value && /\.(mp4|webm|mov)(\?|$)/i.test(value);
  const isEmbed = value ? getEmbedUrl(value, false) !== null : false;

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    setUploading(true);
    try {
      const res = await api.post("/admin/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(res.data.url);
      toast.success("File caricato");
    } catch {
      toast.error("Upload non riuscito. Riprova.");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div data-testid={testId} className="border border-line p-4">
      <p className="text-[10px] font-mono tracking-[0.25em] text-fog uppercase mb-3">{label}</p>
      {value ? (
        <div className="relative mb-3">
          {isEmbed ? (
            <div className="w-full aspect-video bg-coal flex items-center justify-center text-fog text-[10px] font-mono tracking-[0.2em]">
              VIDEO YOUTUBE / VIMEO COLLEGATO
            </div>
          ) : isVideo ? (
            <video src={value} className="w-full aspect-video object-cover bg-coal" muted playsInline preload="metadata" />
          ) : (
            <img src={value} alt={label} className="w-full aspect-video object-cover bg-coal" />
          )}
          <button
            type="button"
            data-testid={`${testId}-clear`}
            onClick={() => onChange("")}
            className="absolute top-2 right-2 w-7 h-7 bg-night/80 border border-line flex items-center justify-center text-fog hover:text-gold"
            aria-label="Rimuovi"
          >
            <X size={12} />
          </button>
        </div>
      ) : (
        <div className="mb-3 w-full aspect-video bg-coal flex items-center justify-center text-fog/40 text-xs font-mono tracking-[0.2em]">
          NESSUN FILE
        </div>
      )}
      <div className="flex gap-2">
        <input
          data-testid={`${testId}-url`}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://… oppure carica un file"
          className="flex-1 bg-surface border border-line px-3 py-2.5 text-xs text-bone placeholder:text-fog/40 focus:border-gold focus:outline-none transition-colors duration-300"
        />
        <button
          type="button"
          data-testid={`${testId}-upload`}
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="inline-flex items-center gap-2 px-4 py-2.5 bg-gold text-night text-[10px] font-semibold tracking-[0.15em] hover:bg-bone disabled:opacity-60 transition-colors duration-300 shrink-0"
        >
          <Upload size={12} /> {uploading ? "CARICO…" : "CARICA"}
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*,video/mp4,video/webm,video/quicktime" onChange={handleFile} className="hidden" />
    </div>
  );
};

export default ImageUpload;
